import LoginView from "@features/auth/view/login-view";

const Login = () => {
  return <LoginView />;
};

export default Login;
